import styled from "styled-components";

const FullScreenLayout = styled.div`
  min-height: 100vh;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
`;

export { FullScreenLayout };
